import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    tempoFeel: {
        id: "meta.tempoFeel",
    },
    timeSignature: {
        id: "meta.timeSignature",
    },
    isUpbeat: {
        id: "meta.isUpbeat",
    },
    rhythmPatterns: {
        id: "meta.rhythmPatterns",
    },
    isRepeat: {
        id: "meta.isRepeat",
    },
    alternating: {
        id: "meta.alternating",
    },
});

export default messages;
